/**
 * @generated SignedSource<<53e84c22517867c880da6c976b95643a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomTemplateProjectBanner$data = {
  readonly isLiveTemplate: boolean | null | undefined;
  readonly " $fragmentType": "CustomTemplateProjectBanner";
};
export type CustomTemplateProjectBanner$key = {
  readonly " $data"?: CustomTemplateProjectBanner$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomTemplateProjectBanner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CustomTemplateProjectBanner",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isLiveTemplate"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "8fa4edcc596948b7b940eaf11aa2562a";

export default node;
